export const LOCAL_STORAGE_KEY_LINK_TO_VIDEO_SCRIPT_GENERATOR = "LINK_TO_VIDEO_SCRIPT_GENERATOR";
export const LOCAL_STORAGE_KEY_VIDEO_COLLECTION_DATA = "VIDEO_COLLECTION_DATA";